import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";
import { HttpResponse } from "@aws-amplify/core/internals/aws-client-utils";

@Injectable({
  providedIn: "root",
})
export class OpenCategoryCoeTransferService {
  constructor(private http: HttpUtilService) {}

  Search(searchOption: string, searchText: string): Observable<any> {
    const encodedSearchOption = encodeURIComponent(
      `"${searchOption}"`,
    );
    const encodedSearchText = encodeURIComponent(`"${searchText}"`);
    return this.http.get(
      `COETransferService.asmx/Search?searchOption=${encodedSearchOption}&searchText=${encodedSearchText}`,
    );
  }

  GetCoeBidDateList(): Observable<any> {
    return this.http.get("COETransferService.asmx/GetCoeBidDateList");
  }

  GetCoeAmtList(): Observable<any> {
    return this.http.get("COETransferService.asmx/GetCoeAmtList");
  }

  GetCoeList(coeAmount: string, coeBidDate: string): Observable<any> {
    const encodedCoeAmount = encodeURIComponent(`"${coeAmount}"`);
    const encodedCoeBidDate = encodeURIComponent(`"${coeBidDate}"`);
    return this.http.get(
      `COETransferService.asmx/GetCoeList?coeAmount=${encodedCoeAmount}&coeBidDate=${encodedCoeBidDate}`,
    );
  }

  GetCOEReport(reportType: string): Observable<any> {
    const encodedReportType = encodeURIComponent(`"${reportType}"`);
    return this.http.get(
      `COETransferService.asmx/GetCOEReport?reportType=${encodedReportType}`,
    );
  }

  GetCOEReservationReport(
    searchText: string,
    CoeAmount?: string | null,
    CoeBidDate?: string | null,
  ): Observable<any> {
    return this.http.post(
      "COETransferService.asmx/GetCOEReservationReport",
      {
        model: {
          CoeAmount,
          CoeBidDate,
          searchOption: "RefNo",
          searchText,
        },
      },
    );
  }

  DropAllocation(model: {
    CaseNo: string;
    CoeAmount: string;
    CoeBidDate: string;
    ColourCode: string;
    ContractNo: string;
    FinCompCode: string;
    IcNo: string;
    ModelShortDesc: string;
    Name: string;
    Option: number;
    RefNo: string;
    SalesmanCode: string;
    SellPrice: number;
    __type: string;
  }): Observable<any> {
    return this.http.post("COETransferService.asmx/DropAllocation", {
      model,
    });
  }

  UpdateCoe(model: {
    CaseNo: string;
    CoeAmount: string;
    CoeBidDate: string;
    ColourCode: string;
    ContractNo: string;
    FinCompCode: string;
    IcNo: string;
    ModelShortDesc: string;
    Name: string;
    Option: number;
    RefNo: string;
    SalesmanCode: string;
    SellPrice: number;
    __type: string;
  }): Observable<any> {
    return this.http.post("COETransferService.asmx/UpdateCoe", {
      model,
    });
  }

  OnContractChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractNo: string,
  ): Observable<any> {
    return this.http.post(
      "COEAllocationService.asmx/OnContractChange",
      {
        model: {
          BidType,
          CoeBidDate,
          CoeCategory,
          CoeDepositAmount,
          CoeExipryDate,
          ContractNo,
        },
      },
    );
  }

  OnNricChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractName: string,
    ContractNo: string,
    Nric: string,
  ): Observable<any> {
    return this.http.post("COEAllocationService.asmx/OnNricChange", {
      model: {
        BidType,
        CoeBidDate,
        CoeCategory,
        CoeDepositAmount,
        CoeExipryDate,
        ContractName,
        ContractNo,
        Nric,
      },
    });
  }

  OnCertificateNoChange(
    BidType: string,
    CoeBidDate: string,
    CoeCategory: string,
    CoeCertificateNo: string,
    CoeDepositAmount: string,
    CoeExipryDate: string,
    ContractName: string,
    ContractNo: string,
    Nric: string,
  ): Observable<any> {
    return this.http.post(
      "COEAllocationService.asmx/OnCertificateNoChange",
      {
        model: {
          BidType,
          CoeBidDate,
          CoeCategory,
          CoeCertificateNo,
          CoeDepositAmount,
          CoeExipryDate,
          ContractName,
          ContractNo,
          Nric,
        },
      },
    );
  }
}
